export default {
  ADD_TICKET_BET: 'ADD_TICKET_BET',
  CLEAR_TICKET: 'CLEAR_TICKET',
  SET_AUTH: 'SET_AUTH',
  SET_CONFIG: 'SET_CONFIG',
  SET_PLATFORM: 'SET_PLATFORM',
  SET_ROUND: 'SET_ROUND',
  SET_NEXT_ROUNDS: 'SET_NEXT_ROUNDS',
  SET_USER: 'SET_USER',
  SET_ALLOWED_SHORTCUT: 'SET_ALLOWED_SHORTCUT',
  SET_SHORTCUTS: 'SET_SHORTCUTS',
  SET_LIMITS: 'SET_LIMITS',
  UPDATE_TICKET: 'UPDATE_TICKET',
  UPDATE_BET: 'UPDATE_BET',
  UPDATE_TICKET_BETS: 'UPDATE_TICKET_BETS',
  UPDATE_BETSLIP_BET: 'UPDATE_BETSLIP_BET',
};
